import React from 'react';

import FeaturedAdList from 'components/FeaturedAd/FeaturedAdList';

const FeaturedAds = () => <FeaturedAdList />;

export default FeaturedAds;
